webpackJsonp([11],{

/***/ 1917:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1942),
  /* template */
  __webpack_require__(1973),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1942:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_v_mask__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_retirada_services__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(13);






/* harmony default export */ __webpack_exports__["default"] = ({
  nome: 'visualizar-pendencias-lote',
  props: {
    documentoLiberacao: {
      type: String,
      required: true
    },
    tipoDocumentoLiberacao: {
      required: true
    },
    grv: {
      required: true
    }
  },
  directives: { mask: __WEBPACK_IMPORTED_MODULE_1_v_mask__["a" /* VueMaskDirective */] },
  data: function data() {
    return {
      lote: null,
      isUploadingFoto: false,
      lances: null,
      lancesLoading: false,
      videoDestaque: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['isLogged', 'currentUser'])),
  mounted: function mounted() {},
  activated: function activated() {},
  created: function created() {
    var _this = this;

    this.$loaderOverlay.open().message('Aguarde enquanto carregamos os dados...');
    __WEBPACK_IMPORTED_MODULE_2__domain_retirada_services__["a" /* default */].verificarPendenciasVeiculo(this.grv, this.tipoDocumentoLiberacao, this.documentoLiberacao).then(function (response) {
      _this.$loaderOverlay.hide();
      _this.lote = response.data;
      console.log(response.data);
    }).catch(function (error) {
      _this.$loaderOverlay.hide();
      alert('Erro ao obter os dados');
      console.log(error);
    });
  },
  beforeDestroy: function beforeDestroy() {},
  deactivated: function deactivated() {
    this.$destroy();
  },

  watch: {},
  methods: {
    round: function round(number, precision) {
      var factor = Math.pow(10, precision);
      var tempNumber = number * factor;
      var roundedTempNumber = Math.round(tempNumber);
      return roundedTempNumber / factor;
    },
    print: function print() {
      window.print();
    },
    adjustFirstLetter: function adjustFirstLetter(v) {
      return v.charAt(0).toLowerCase() + v.slice(1);
    }
  }
});

/***/ }),

/***/ 1973:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.lote !== null) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('div', {
    staticClass: "fade-in-down"
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('p', [_vm._v("\n              Multas: "), _c('strong', [_vm._v(_vm._s(_vm.lote.QuantidadeMultas))]), _vm._v(" "), _c('br'), _vm._v("\n              Indicação Débitos Dad: "), _c('strong', [_vm._v(_vm._s(_vm.lote.IndicacaoDebitosDad))]), _vm._v(" "), _c('br'), _vm._v("\n              Indicação Débitos Seguro: "), _c('strong', [_vm._v(_vm._s(_vm.lote.IndicacaoDebitosSeguro))]), _vm._v(" "), _c('br'), _vm._v("\n              Indicação Débitos Vistoria: "), _c('strong', [_vm._v(_vm._s(_vm.lote.IndicacaoDebitosVistoria))]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "m-t-lg"
  }, [_vm._v("\n              Débitos IPVA:"), _c('br')]), _vm._v(" "), _vm._l(((_vm.lote.DebitoIpva || []).filter(function (item) { return item; })), function(debito) {
    return _c('div', [_vm._v("\n              - "), _c('strong', [_vm._v(_vm._s(debito))]), _c('br')])
  }), _vm._v(" "), _c('p', {
    staticClass: "m-t-lg"
  }, [_vm._v("\n              Cod Sub Restrições Administrativas:"), _c('br')]), _vm._v(" "), _vm._l(((_vm.lote.CodSubRestricoesAdministrativas || []).filter(function (item) { return item; })), function(debito) {
    return _c('div', [_vm._v("\n              - "), _c('strong', [_vm._v(_vm._s(debito))]), _c('br')])
  }), _vm._v(" "), _c('p', {
    staticClass: "m-t-lg"
  }, [_vm._v("\n              Cod Sub Restrições Jurídicas:"), _c('br')]), _vm._v(" "), _vm._l(((_vm.lote.CodSubRestricoesJudicias || []).filter(function (item) { return item; })), function(debito) {
    return _c('div', [_vm._v("\n              - "), _c('strong', [_vm._v(_vm._s(debito))]), _c('br')])
  }), _vm._v(" "), _c('p', {
    staticClass: "m-t-lg"
  }, [_vm._v("\n              Pendências:"), _c('br')]), _vm._v(" "), _vm._l(((_vm.lote.DescricaoPendencias || []).filter(function (item) { return item; })), function(debito) {
    return _c('div', [_vm._v("\n              - "), _c('strong', [_vm._v(_vm._s(debito))]), _c('br')])
  }), _vm._v(" "), _c('p', {
    staticClass: "m-t-lg"
  }, [_vm._v("\n              Restrições Administrativas:"), _c('br')]), _vm._v(" "), _vm._l(((_vm.lote.RestricoesAdministrativas || []).filter(function (item) { return item; })), function(debito) {
    return _c('div', [_vm._v("\n              - "), _c('strong', [_vm._v(_vm._s(debito))]), _c('br')])
  }), _vm._v(" "), _c('p', {
    staticClass: "m-t-lg"
  }, [_vm._v("\n              Restrições Judiciais:"), _c('br')]), _vm._v(" "), _vm._l(((_vm.lote.RestricoesJudiciais || []).filter(function (item) { return item; })), function(debito) {
    return _c('div', [_vm._v("\n              - "), _c('strong', [_vm._v(_vm._s(debito))]), _c('br')])
  })], 2)])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/11.19aa8c7f6ac795b329fd.js